import React from 'react';
import { ScrollText, ShieldCheck, UserCheck, AlertTriangle } from 'lucide-react';

export const TermsAndConditions: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="bg-gray-900 p-8 md:p-12 text-white relative">
            <div className="absolute top-0 right-0 p-8 opacity-10">
              <ScrollText className="w-32 h-32" />
            </div>
            <h1 className="text-3xl md:text-4xl font-extrabold mb-4">Syarat & Ketentuan</h1>
            <p className="text-gray-400 max-w-xl">
              Harap baca syarat dan ketentuan ini dengan saksama sebelum menggunakan layanan kami.
            </p>
          </div>

          <div className="p-8 md:p-12 space-y-10">
            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-indigo-100 p-2 rounded-lg">
                  <UserCheck className="w-6 h-6 text-giz-primary" />
                </div>
                <h2 className="text-xl font-bold text-gray-900">1. Ketentuan Umum</h2>
              </div>
              <div className="space-y-3 text-gray-600 leading-relaxed">
                <p>Dengan mengakses atau melakukan pembelian tiket melalui Surabaya Ticket, Anda setuju untuk terikat oleh syarat dan ketentuan ini.</p>
                <p>Layanan kami menyediakan platform untuk pembelian tiket wahana di Kebun Binatang Surabaya, termasuk namun tidak terbatas pada GIZ Park dan Rabbits In Wonderland.</p>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-green-100 p-2 rounded-lg">
                  <ShieldCheck className="w-6 h-6 text-green-600" />
                </div>
                <h2 className="text-xl font-bold text-gray-900">2. Pembelian & Pembayaran</h2>
              </div>
              <div className="space-y-3 text-gray-600 leading-relaxed">
                <ul className="list-disc pl-5 space-y-2">
                  <li>Pembayaran harus dilakukan secara penuh sesuai dengan harga yang tertera pada saat transaksi.</li>
                  <li>Metode pembayaran yang tersedia meliputi QRIS dan transfer bank melalui gerbang pembayaran iPaymu.</li>
                  <li>E-Tiket akan diterbitkan hanya setelah pembayaran berhasil diverifikasi oleh sistem kami.</li>
                  <li>Kesalahan dalam pengisian data diri (email/nomor HP) sepenuhnya merupakan tanggung jawab pembeli.</li>
                </ul>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-orange-100 p-2 rounded-lg">
                  <AlertTriangle className="w-6 h-6 text-orange-600" />
                </div>
                <h2 className="text-xl font-bold text-gray-900">3. Penggunaan Tiket</h2>
              </div>
              <div className="space-y-3 text-gray-600 leading-relaxed">
                <ul className="list-disc pl-5 space-y-2">
                  <li>Satu tiket berlaku untuk satu orang sesuai dengan kategori yang dipilih.</li>
                  <li>Tiket hanya berlaku pada tanggal kunjungan yang telah dipilih saat transaksi.</li>
                  <li>Petugas berhak menolak akses jika QR Code tiket tidak valid atau sudah pernah digunakan.</li>
                  <li>Dilarang keras menyalin, memalsukan, atau menjual kembali tiket yang sudah dibeli tanpa izin resmi.</li>
                </ul>
              </div>
            </section>

            <section className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
              <h3 className="font-bold text-gray-900 mb-2">Pembaruan Ketentuan</h3>
              <p className="text-sm text-gray-500 italic">
                Kami berhak untuk mengubah atau mengganti syarat dan ketentuan ini kapan saja. Perubahan akan berlaku segera setelah dipublikasikan di halaman ini. Terakhir diperbarui: 27 Desember 2025.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
